<template>
  <div class="content">
    <h2 class="page-title">ホーム</h2>
    <section id="home-info">
      <h4 class="page-sub-title pl-2 pl-md-4 mt-3 mt-md-5">お知らせ</h4>
      <div v-if="async.info" class="spinner">
        <md-progress-spinner md-mode="indeterminate" />
      </div>
      <div v-else>
        <dl v-if="infomations.title" class="info-title my-1 row mx-auto">
          <dt class="col-md-2">現状の輸送状況：</dt>
          <dd class="col-md-10">{{ infomations.title }}</dd>
        </dl>

        <div class="bg-gray p-2 m-2">
          <div class="table-wrapper">
            <table v-if="infomations.body.length" class="w-100 bg-white">
              <tbody>
                <tr v-for="data in infomations.body" :key="data.id">
                  <td class="p-0 pt-1 p-md-2">
                    {{ dateFormat(data.KOSHIN_NICHIJI) }}
                  </td>
                  <td class="p-0 pt-1 pl-2 p-md-2 bold">{{ data.TITLE }}</td>
                  <td
                    class="p-0 pt-1 pl-2 p-md-2"
                    v-html="sanitize(data.MESSAGE)"
                  />
                </tr>
              </tbody>
            </table>
            <div v-else class="text-center pt-5">
              現在、お知らせはありません。
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="home-menu">
      <h4 class="page-sub-title pl-2 pl-md-4 mt-5">メニュー</h4>
      <div class="menu-wrapper ml-sm-4">
        <div class="row mx-auto">
          <div class="card-wrapper">
            <b-card tag="article" class="mb-2">
              <div class="md-icon-wrapper">
                <md-icon class="card-img-top">monetization_on</md-icon>
              </div>
              <div class="px-3 px-md-4 py-2">
                <h5 class="card-title bold">料金・納期</h5>
                <p>
                  <md-button :to="{ name: 'TrialIndex' }" class="md-primary">
                    料金・納期検索
                    <font-awesome-icon icon="arrow-circle-right" />
                  </md-button>
                </p>
              </div>
            </b-card>
          </div>
          <div class="card-wrapper">
            <b-card tag="article" class="mb-2">
              <div class="md-icon-wrapper">
                <md-icon class="md-size-2x card-img-top">
                  assignment_turned_in
                </md-icon>
              </div>
              <div class="px-3 px-md-4 py-2">
                <h5 class="card-title bold">発注</h5>
                <p>
                  <md-button @click="checkYoshin" class="md-primary">
                    発注
                    <font-awesome-icon icon="arrow-circle-right" />
                  </md-button>
                </p>
              </div>
            </b-card>
          </div>
          <div class="card-wrapper">
            <b-card tag="article" class="mb-2">
              <div class="md-icon-wrapper">
                <md-icon class="card-img-top">history</md-icon>
              </div>
              <div class="px-3 px-md-4 py-2">
                <h5 class="card-title bold">発注履歴</h5>
                <p>
                  <md-button :to="{ name: 'HistoryIndex' }" class="md-primary">
                    先月・当月分
                    <font-awesome-icon icon="arrow-circle-right" />
                  </md-button>
                </p>
                <p>
                  <md-button @click="gotoHistory([1, 2, 3])" class="md-primary">
                    輸送中
                    <font-awesome-icon icon="arrow-circle-right" />
                  </md-button>
                </p>
                <p>
                  <md-button @click="gotoHistory([4])" class="md-primary">
                    納車済み
                    <font-awesome-icon icon="arrow-circle-right" />
                  </md-button>
                </p>
              </div>
            </b-card>
          </div>
          <div class="card-wrapper">
            <b-card tag="article" class="mb-2">
              <div class="md-icon-wrapper">
                <md-icon class="md-size-2x card-img-top">build</md-icon>
              </div>
              <div class="px-3 px-md-4 py-2">
                <h5 class="card-title bold">設定</h5>
                <p>
                  <md-button :to="{ name: 'SettingEdit' }" class="md-primary">
                    個人設定
                    <font-awesome-icon icon="arrow-circle-right" />
                  </md-button>
                </p>
                <p>
                  <md-button :to="{ name: 'SettingCreate' }" class="md-primary">
                    アカウント作成
                    <font-awesome-icon icon="arrow-circle-right" />
                  </md-button>
                </p>
                <p>
                  <md-button
                    :to="{ name: 'SettingCompanyIndex' }"
                    class="md-primary"
                  >
                    グループ設定
                    <font-awesome-icon icon="arrow-circle-right" />
                  </md-button>
                </p>
              </div>
            </b-card>
          </div>
          <div class="card-wrapper">
            <b-card tag="article" class="mb-2">
              <div class="md-icon-wrapper">
                <md-icon class="md-size-2x card-img-top">contact_mail</md-icon>
              </div>
              <div class="px-3 px-md-4 py-2">
                <h5 class="card-title bold">お問い合わせ</h5>
                <p>
                  <md-button :to="{ name: 'InquiryIndex' }" class="md-primary">
                    お問い合わせ
                    <font-awesome-icon icon="arrow-circle-right" />
                  </md-button>
                </p>
              </div>
            </b-card>
          </div>
          <div class="card-wrapper" />
        </div>
      </div>
    </section>

    <section id="home-order-status">
      <h4 class="page-sub-title pl-2 pl-md-4 mt-5">発注状況</h4>
      <select
        v-if="groups.length"
        :class="[
          'form-control col-md-5 col-10',
          isMobile ? 'm-auto' : 'ml-auto',
        ]"
        v-model="search.JYUCYU_SHIKI_CD"
        @change="setHistory()"
      >
        <option value="all" key="all">全て</option>
        <option value="" key="">
          {{ $store.state.user.data.hum_torihiki.SOFU_SAKI_MEI }}
        </option>
        <option
          v-for="(item, key) in groups"
          :value="item.JYUCYU_SHIKI_CD"
          :key="key"
        >
          {{ item.SOFU_SAKI_MEI }}
        </option>
      </select>
      <div v-if="async.history" class="spinner">
        <md-progress-spinner md-mode="indeterminate" />
      </div>
      <div v-else>
        <md-table
          v-if="orders.length"
          class="mt-2 mx-2 p-2 bg-gray h-400"
          v-model="orders"
          md-sort="JYUCHU_BI"
          md-sort-order="asc"
          md-card
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="発注日" md-sort-by="JYUCHU_BI">
              <span v-if="!isMobile">{{ dateFormat(item.JYUCHU_BI) }}</span>
              <div v-else class="row mx-0">
                <p class="col-5 bold">発注日</p>
                <p class="col-7">{{ item.KOSHIN_NICHIJI }}</p>
              </div>
            </md-table-cell>

            <md-table-cell
              md-label="貴社管理番号"
              md-sort-by="KISYA_KANRI_BANGO"
            >
              <span v-if="!isMobile">{{ item.KISYA_KANRI_BANGO }}</span>
              <div v-else class="row mx-0">
                <p class="col-5 bold blue">貴社管理番号</p>
                <p class="col-7">{{ item.KISYA_KANRI_BANGO }}</p>
              </div>
            </md-table-cell>

            <md-table-cell md-label="車名" md-sort-by="SYARYO_MEI">
              <span v-if="!isMobile">{{ item.SYARYO_MEI }}</span>
              <div v-else class="row mx-0">
                <p class="col-5 bold blue">車名</p>
                <p class="col-7">{{ item.SYARYO_MEI }}</p>
              </div>
            </md-table-cell>

            <md-table-cell
              md-label="引取先"
              md-sort-by="navi_jyuchu.HIKITORI_MEI"
            >
              <span v-if="!isMobile">
                {{ omitText(item.navi_jyuchu.HIKITORI_MEI, 20) }}
              </span>
              <div v-else class="row mx-0">
                <p class="col-5 bold blue">引取先</p>
                <p class="col-7">{{ item.navi_jyuchu.HIKITORI_MEI }}</p>
              </div>
            </md-table-cell>

            <md-table-cell md-label="納車先" md-sort-by="navi_jyuchu.NOSYA_MEI">
              <span v-if="!isMobile">
                {{ omitText(item.navi_jyuchu.NOSYA_MEI, 20) }}
              </span>
              <div v-else class="row mx-0">
                <p class="col-5 bold blue">納車先</p>
                <p class="col-7">{{ item.navi_jyuchu.NOSYA_MEI }}</p>
              </div>
            </md-table-cell>

            <md-table-cell md-label="ステータス" md-sort-by="SYARYO_STATUS">
              <span
                v-if="!isMobile"
                :class="{ red: Number(item.SYARYO_STATUS) === 9 }"
              >
                {{ getSyaryoStatus(item.SYARYO_STATUS, item.IS_JIZEN_RENRAKU).text }}
              </span>
              <div v-else class="row mx-0">
                <p class="col-5 bold blue">ステータス</p>
                <p
                  :class="['col-7', { red: Number(item.SYARYO_STATUS) === 9 }]"
                >
                  {{
                    getSyaryoStatus(item.SYARYO_STATUS, item.IS_JIZEN_RENRAKU)
                      .text
                  }}
                </p>
              </div>
            </md-table-cell>

            <md-table-cell md-label="" class="text-right">
              <b-button
                class="btn-success detail-btn"
                @click="gotoHistoryDetail(item)"
              >
                詳細
              </b-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
        <div v-else class="text-center mt-3">発注中のデータはありません。</div>
      </div>
    </section>

    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      :md-active.sync="isYoshiFukaModal"
      md-title=""
      :md-content="getHcbApiErrorMessage('untrust')"
      md-confirm-text="問い合わせる"
      md-cancel-text="キャンセル"
      :md-click-outside-to-close="true"
      @md-confirm="gotoInquiry"
    />
  </div>
</template>
<script>
import {getSyaryoStatus} from '@/constants/syaryoStatus'
import Store from '@/store/index.js'
import Mixin from './mixin/Mixin'

const MAX_TABLE_RECORD = 8 // テーブルにスクロールしないで表示するレコード数の最大値
const ROW_HEIGHT = 70
export default {
  name: 'Home',
  components: {},
  mixins: [Mixin],
  data: () => ({
    search: {
      JYUCYU_SHIKI_CD: '',
    },
    async: {
      info: false,
      history: false,
    },
    infomations: {
      title: '',
      body: [],
    },
    groups: [],
    orders: [], // 発注状況
    isYoshiFukaModal: false, // 与信不可モーダル表示フラグ
  }),
  methods: {
    getSyaryoStatus,
    setHistory() {
      this.async.history = true
      return Store.dispatch('history/getHistory', this.search)
        .then((res) => {
          this.orders = res.data
          this.async.history = false
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
    },
    setInfo() {
      this.async.info = true
      this.getInfo({
        cond: {
          IS_DISPLAY_FLG: 1,
        },
        fields: {
          osiraseBody: ['KOSHIN_NICHIJI', 'MESSAGE', 'TITLE'],
        },
      }).then((res) => {
        this.infomations = {
          title: res.data.title ? res.data.title.MESSAGE : '',
          body: res.data.body,
        }
        this.async.info = false
      })
    },
    gotoHistory(status) {
      this.$router.push({
        name: 'HistoryIndex',
        params: { search_conds: { STATUS: status } },
      })
    },
    gotoHistoryDetail(item) {
      this.$store.state.history.JYUCYU_SHIKI_CD = this.search.JYUCYU_SHIKI_CD
      this.$router.push({ path: `/history/detail/${item.ID}` })
    },
    // グループ一覧設定
    setGroupList() {
      return Store.dispatch('group/get')
        .then((res) => {
          if (res.data[0]) {
            this.groups = res.data[0].group_torihiki
            this.search.JYUCYU_SHIKI_CD = 'all'
          }
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
    },
    /**
     * 与信不可か確認し不可の場合はアラートを表示
     * 問題ない場合は発注画面に遷移する
     */
    checkYoshin() {
      if (this.isYoshinFuka) this.isYoshiFukaModal = true
      else this.$router.push({ name: 'OrderIndex' })
    },
  },
  computed: {
    torihiki() {
      return this.$store.state.user.data.hum_torihiki
    },
  },
  async created() {
    await this.setGroupList()
    this.setHistory()
    this.setInfo()
  },
}
</script>

<style lang="sass" scoped>
@import '../assets/css/logico2'
section#home-info
  dt
  @include sp
    font-size: 14px
  .table-wrapper
    font-size: 0.85em
    width: 100%
    margin: 0 auto
    overflow: auto
    @include sp
      width: 100%
      font-size: 14px
    table
      tbody
        tr:nth-child(even)
          background-color: #fafafa;
        tr
          td
            padding: .6em 1.0em
          td:nth-child(1)
            width: 12%
            color: #666;
          td:nth-child(2)
            width: 33%
          td:nth-child(3)
            width: 55%
section#home-menu
  .md-primary
    text-align: left
    @include sp
      font-size: 14px
  .menu-wrapper
    .card-wrapper
      width: 18%
      margin-right: 20px
      @include sp
        margin: 0 auto
        width: 46%
      .card-title
        margin: 0
        font-size: 16px
      .card-body
        padding: 0
        min-height: 190px
        @include sp
          min-height: 150px
      .md-icon-wrapper
        height: 45px
        text-align: center
        background: $baseBlueColor
        font-size: 30px !important
      .md-icon
        color: #fff !important
        font-size: 30px !important
        padding-bottom: 5px
      .md-button
        margin: 0
section#home-order-status
  .detail-btn
    font-weight: bold
    color: white
  @include sp
    td
      font-size: 14px
      .md-table-cell-container
        padding: 6px 5px 6px 5px
    td:nth-child(1)
      background-color: $baseBlueColor
      color: white
</style>



// WEBPACK FOOTER //
// src/components/Home.vue